import { usePage } from "@inertiajs/react"

import type { Auth, SharedData } from "@/types"

export function useAuth(): Auth | null {
  const { auth } = usePage<SharedData>().props
  return auth
}

export function useSharedData(): SharedData {
  return usePage<SharedData>().props
}
